<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    show: {
        tyoe: Boolean,
        default: false
    },
    listing: {
        type: Object,
        required: true
    }
})

const emit = defineEmits(['confirm', 'close']);

const formatDate = (date) => {
    if(!date) return 'Does not expire';
    return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

const formatPrice = (price) => {
    const numPrice = parseFloat(price);
    return numPrice.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2, currency: 'USD', style: 'currency' });
}

const handleConfirm = () => {   
    emit('confirm');
}

</script>

<template>
    <Teleport to="body">
        <div v-if="props.show" class="modal-overlay" data-modal>
            <div ref="modalRef" class="modal">
                <div class="modal__header">
                    <h2 class="modal__title">{{ listing.name }}</h2>
                </div>
                <div class="grid grid-cols-5 gap-4">
                    <div class=col-span-1>
                        <img :src="listing.preview_image" alt="Listing" class="w-full h-full object-cover rounded-lg">
                    </div>
                    <div class="col-span-4 flex flex-col gap-2">
                        <div class="flex justify-between text-sm">
                            <div class="bg-echoes-background-black/30 px-2 py-1 rounded-lg">Issuer: {{ listing.applicant.username }}</div>
                            <div class="bg-echoes-background-black/30 px-2 py-1 rounded-lg">Reward: {{ formatPrice(listing.price) }}</div>
                            <div class="bg-echoes-background-black/30 px-2 py-1 rounded-lg">Deadline: {{ formatDate(listing.expire_at) }}</div>
                        </div>
                        <div class="text-white/60 text-sm">You'll be switched to Data Studio to submit your proposal. There you can include details about how you plan to answer this RFP and submit it to the issuer for review.</div>
                    </div>
                    
                </div>
                <div class="modal__footer">
                    <button class="px-4 py-2 rounded-lg hover:bg-white/10 text-white" @click="emit('close')">Cancel</button>
                    <button class="text-white px-4 py-2 rounded-lg bg-echoes-primary hover:bg-echoes-primary/80" @click="handleConfirm">Open Data Studio</button>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<style scoped lang="postcss">
.modal-overlay {
    @apply fixed inset-0 bg-black/50 flex items-center justify-center z-40 p-2;
    backdrop-filter: blur(4px);
    animation: fadeIn 0.2s ease;
    isolation: isolate;
}

.modal {
    @apply bg-echoes-background-gray border border-echoes-border-gray/50 rounded-xl shadow-xl max-h-[85vh] mt-16 flex flex-col w-1/2 px-4;
    animation: slideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    z-index: 1;
}

.modal__header {
    @apply sticky top-0 z-10 flex items-center justify-between pt-4 p-2 border-b border-echoes-border-gray bg-echoes-background-gray rounded-t-xl;
}

.modal__title {
    @apply text-xl font-semibold text-white flex items-center gap-2;
}

.modal__details {
    @apply mx-2 px-4 py-2 bg-echoes-background-black rounded-xl my-2;
}

.modal__footer {
    @apply px-2 bg-echoes-background-gray rounded-b-xl text-sm text-white/60 flex justify-end my-4 gap-4;
}
</style>